/**
 * Arredonda um número para um número específico de casas decimais
 * @param {number} value - O valor a ser arredondado
 * @param {number} decimals - Número de casas decimais (padrão: 2)
 * @returns {number} O valor arredondado como número
 */
export function roundToDecimals(value, decimals = 2) {
  return Number(value.toFixed(decimals))
}
